const state = {
	locations: [],
	selectedCountry: "",
	selectedRegion: "",
	selectedSubRegion: "",
	selectedOutlet: "",
	storeSections: [],
	showSectionModal: false,
	sectionData: {
		store: "",
		department: null,
		name: "",
		applicable_functions: [],
		transaction_threshold: 0,
	},
	dailyActivities: [],
	coverageActivities: [],
	functions: [],
	departments: [],
	designations: [],
	outlets: [],
	showCoverageActivity: false,
	coverageActivityDetails: {},
	planning: [
		{
			name: "Item Prep Time Per Hour",
			value: "item prep time per hr",
		},
		// {
		// 	name: "Quantity Sold Per Hour",
		// 	value: "quantity",
		// },
		{
			name: "Quantity Sold Per Hour",
			value: "quantity per hr",
		},
		{
			name: "Transactions Per Hour",
			value: "transaction per hr",
		},
		{
			name: "Footfall Per Hour",
			value: "footfall per hr",
		},
	],
	selectedSections: "",
	selectedFunctions: "",
	planningType: "",
	/*
	addTime_list: [
		{ name: "Overall Average Time", value: 1 },
		{ name: "Category", value: 2 },
		{ name: "Subcategory", value: 4 },
		{ name: "Department", value: 3 },
	],
	*/
	addTime_list: [
		{ name: "Overall Average Time", value: 'Overall Average Time' },
		{ name: "Category", value: 'Category' },
		{ name: "Subcategory", value: 'Subcategory' },
		{ name: "Department", value: 'Department' },
	],
	averageTimePerCategory: [
		{
			id: "",
			function: "",
			department: "",
			category: [],
			subcategory: [],
			transaction_threshold: [],
			higher_threshold: 0,
			lower_threshold: 0,
			hours: "",
			minutes: "",
			seconds: "",
		},
	],
	category_list: [],
	numTeancListData: [
		{
			function: "",
			basis: "",
			range_start: 0,
			range_end: 0,
			start: (min = 0, max = 1000, step = 1) => {
				let arr = [];
				for (let i = min; i <= max; i += step) {
					arr.push(i);
				}
				return arr;
			},
			end: (min = 0, max = 1000, step = 1) => {
				let arr = [];
				for (let i = min; i <= max; i += step) {
					arr.push(i);
				}
				return arr;
			},
			range_requirement: 0,
		},
		// {
		// 	function: "",
		// 	basis: "",
		// 	range_start: 0,
		// 	range_end: 0,
		// 	start: (min = 0, max = 1000, step = 1) => {
		// 		let arr = [];
		// 		for (let i = min; i <= max; i += step) {
		// 			arr.push(i);
		// 		}
		// 		return arr;
		// 	},
		// 	end: (min = 0, max = 1000, step = 1) => {
		// 		let arr = [];
		// 		for (let i = min; i <= max; i += step) {
		// 			arr.push(i);
		// 		}
		// 		return arr;
		// 	},
		// 	range_requirement: 0,
		// },
	],
	transactionActivitiesList: [
		{
			id: "",
			function: "",
			department: "",
			name: "",
			hours: "",
			minutes: "",
			seconds: "",
		},
	],
	orderTypeList: [],
	department_list: [],
	is_admin: "",
	preparation_activity: [],
	add_time: null,
	planningLevel: "category",
	departmentActivities: [
		{
			id: "",
			function: "",
			department: "",
			product_department: "",
			category: "",
			hours: "",
			minutes: "",
			seconds: "",
		},
	],
	selected_categories: [],
	selectPlanningLevelDepartment: [],
	selectedSubCategories: [],
	subcategoryList: [],
	change_keys: false,
	overallAverage: {
		hours: 0,
		minutes: 0,
		seconds: 0,
	},
	subCategoryActivityList: [
		{
			id: "",
			function: "",
			department: "",
			category: "",
			subcategory: [],
			transaction_threshold: [],
			higher_threshold: 0,
			lower_threshold: 0,
			hours: "",
			minutes: "",
			seconds: "",
		},
	],
	selectedDepartmentList: [],
	transactionThresholdRange: [],
	durationList: [],
	showNonCoverageActivityPopup: false,
	selectedFrequency: "",
	selectedPlanBy: "",
	editSectionActivity: false,
	selectedOrderType: "",
	hoursArr: [
		{
			label: "00",
			value: 0,
		},
		{
			label: "01",
			value: 1,
		},
		{
			label: "02",
			value: 2,
		},
		{
			label: "03",
			value: 3,
		},
		{
			label: "04",
			value: 4,
		},
		{
			label: "05",
			value: 5,
		},
		{
			label: "06",
			value: 6,
		},
		{
			label: "07",
			value: 7,
		},
		{
			label: "08",
			value: 8,
		},
		{
			label: "09",
			value: 9,
		},
		{
			label: "10",
			value: 10,
		},
		{
			label: "11",
			value: 11,
		},
		{
			label: "12",
			value: 12,
		},
		{
			label: "13",
			value: 13,
		},
		{
			label: "14",
			value: 14,
		},
		{
			label: "15",
			value: 15,
		},
		{
			label: "16",
			value: 16,
		},
		{
			label: "17",
			value: 17,
		},
		{
			label: "18",
			value: 18,
		},
		{
			label: "19",
			value: 19,
		},
		{
			label: "20",
			value: 20,
		},
		{
			label: "21",
			value: 21,
		},
		{
			label: "22",
			value: 22,
		},
		{
			label: "23",
			value: 23,
		},
	],
	minsAndSecArr: [
		{
			label: "00",
			value: 0,
		},
		{
			label: "01",
			value: 1,
		},
		{
			label: "02",
			value: 2,
		},
		{
			label: "03",
			value: 3,
		},
		{
			label: "04",
			value: 4,
		},
		{
			label: "05",
			value: 5,
		},
		{
			label: "06",
			value: 6,
		},
		{
			label: "07",
			value: 7,
		},
		{
			label: "08",
			value: 8,
		},
		{
			label: "09",
			value: 9,
		},
		{
			label: "10",
			value: 10,
		},
		{
			label: "11",
			value: 11,
		},
		{
			label: "12",
			value: 12,
		},
		{
			label: "13",
			value: 13,
		},
		{
			label: "14",
			value: 14,
		},
		{
			label: "15",
			value: 15,
		},
		{
			label: "16",
			value: 16,
		},
		{
			label: "17",
			value: 17,
		},
		{
			label: "18",
			value: 18,
		},
		{
			label: "19",
			value: 19,
		},
		{
			label: "20",
			value: 20,
		},
		{
			label: "21",
			value: 21,
		},
		{
			label: "22",
			value: 22,
		},
		{
			label: "23",
			value: 23,
		},
		{
			label: "24",
			value: 24,
		},
		{
			label: "25",
			value: 25,
		},
		{
			label: "26",
			value: 26,
		},
		{
			label: "27",
			value: 27,
		},
		{
			label: "28",
			value: 28,
		},
		{
			label: "29",
			value: 29,
		},
		{
			label: "30",
			value: 30,
		},
		{
			label: "31",
			value: 31,
		},
		{
			label: "32",
			value: 32,
		},
		{
			label: "33",
			value: 33,
		},
		{
			label: "34",
			value: 34,
		},
		{
			label: "35",
			value: 35,
		},
		{
			label: "36",
			value: 36,
		},
		{
			label: "37",
			value: 37,
		},
		{
			label: "38",
			value: 38,
		},
		{
			label: "39",
			value: 39,
		},
		{
			label: "40",
			value: 40,
		},
		{
			label: "41",
			value: 41,
		},
		{
			label: "42",
			value: 42,
		},
		{
			label: "43",
			value: 43,
		},
		{
			label: "44",
			value: 44,
		},
		{
			label: "45",
			value: 45,
		},
		{
			label: "46",
			value: 46,
		},
		{
			label: "47",
			value: 47,
		},
		{
			label: "48",
			value: 48,
		},
		{
			label: "49",
			value: 49,
		},
		{
			label: "50",
			value: 50,
		},
		{
			label: "51",
			value: 51,
		},
		{
			label: "52",
			value: 52,
		},
		{
			label: "53",
			value: 53,
		},
		{
			label: "54",
			value: 54,
		},
		{
			label: "55",
			value: 55,
		},
		{
			label: "56",
			value: 56,
		},
		{
			label: "57",
			value: 57,
		},
		{
			label: "58",
			value: 58,
		},
		{
			label: "59",
			value: 59,
		},
	],
	quantityArr: [],
	store_details_id: "",
	planType: "",
	selected_function_list: [],
	filter_functions: [],
	filter_functionsList: [],
	non_coverage_activities: [],
	sectionFunctionData: {
		enabled: false,
		id: null,
		store: "",
		store_section: null,
		function: null,
		activities: [],
		mapped_functions: [],
	},
	searchedSection: "",
	searchedCoverageActivity: "",
	hideShowNonCoverageActivity: false,
	selectedFilterSections: [],
	selectedFilterStations: [],
	days: [
		{
			label: "Mon",
			value: 2,
		},
		{
			label: "Tue",
			value: 3,
		},
		{
			label: "Wed",
			value: 4,
		},
		{
			label: "Thu",
			value: 5,
		},
		{
			label: "Fri",
			value: 6,
		},
		{
			label: "Sat",
			value: 7,
		},
		{
			label: "Sun",
			value: 8,
		},
	],
	selectedFilterDays: [],
	testNonCoverageActivityData:
	[
		{
			"Station": "Backroom",
			"timings": {
				"6 AM": "0",
				"7 AM": "1",
				"8 AM": "0",
				"9 AM": "1",
				"10 AM": "0",
				"11 AM": "1",
				"12 PM": "0",
				"1 PM": "1",
				"2 PM": "0",
				"3 PM": "1",
				"4 PM": "0",
				"5 PM": "1",
				"6 PM": "0",
				"7 PM": "1",
				"8 PM": "0",
				"9 PM": "1",
				"10 PM": "0",
				"11 PM": "1",
				"12 AM": "0",
				"1 AM": "1",
				"2 AM": "0",
				"3 AM": "1",
				"4 AM": "0",
				"5 AM": "1"
			},
		},
		{
			"Station": "Safe Cashier",
			"timings": {
				"6 AM": "1",
				"7 AM": "0",
				"8 AM": "1",
				"9 AM": "0",
				"10 AM": "1",
				"11 AM": "0",
				"12 PM": "1",
				"1 PM": "0",
				"2 PM": "1",
				"3 PM": "0",
				"4 PM": "1",
				"5 PM": "0",
				"6 PM": "1",
				"7 PM": "0",
				"8 PM": "1",
				"9 PM": "0",
				"10 PM": "1",
				"11 PM": "0",
				"12 AM": "1",
				"1 AM": "0",
				"2 AM": "1",
				"3 AM": "0",
				"4 AM": "1",
				"5 AM": "0",
			},
		},
		{
			"Station": "GEL",
			"timings": {
				"6 AM": "0",
				"7 AM": "1",
				"8 AM": "0",
				"9 AM": "1",
				"10 AM": "0",
				"11 AM": "1",
				"12 PM": "0",
				"1 PM": "1",
				"2 PM": "0",
				"3 PM": "1",
				"4 PM": "0",
				"5 PM": "1",
				"6 PM": "0",
				"7 PM": "1",
				"8 PM": "0",
				"9 PM": "1",
				"10 PM": "0",
				"11 PM": "1",
				"12 AM": "0",
				"1 AM": "1",
				"2 AM": "0",
				"3 AM": "1",
				"4 AM": "0",
				"5 AM": "1"
			},
		},
		{
			"Station": "Closing",
			"timings": {
				"6 AM": "1",
				"7 AM": "0",
				"8 AM": "1",
				"9 AM": "0",
				"10 AM": "1",
				"11 AM": "0",
				"12 PM": "1",
				"1 PM": "0",
				"2 PM": "1",
				"3 PM": "0",
				"4 PM": "1",
				"5 PM": "0",
				"6 PM": "1",
				"7 PM": "0",
				"8 PM": "1",
				"9 PM": "0",
				"10 PM": "1",
				"11 PM": "0",
				"12 AM": "1",
				"1 AM": "0",
				"2 AM": "1",
				"3 AM": "0",
				"4 AM": "1",
				"5 AM": "0",
			},
		},
		{
			"Station": "Opening",
			"timings": {
				"6 AM": "0",
				"7 AM": "1",
				"8 AM": "0",
				"9 AM": "1",
				"10 AM": "0",
				"11 AM": "1",
				"12 PM": "0",
				"1 PM": "1",
				"2 PM": "0",
				"3 PM": "1",
				"4 PM": "0",
				"5 PM": "1",
				"6 PM": "0",
				"7 PM": "1",
				"8 PM": "0",
				"9 PM": "1",
				"10 PM": "0",
				"11 PM": "1",
				"12 AM": "0",
				"1 AM": "1",
				"2 AM": "0",
				"3 AM": "1",
				"4 AM": "0",
				"5 AM": "1"
			},
		},
		{
			"Station": "Lobby",
			"timings": {
				"6 AM": "1",
				"7 AM": "0",
				"8 AM": "1",
				"9 AM": "0",
				"10 AM": "1",
				"11 AM": "0",
				"12 PM": "1",
				"1 PM": "0",
				"2 PM": "1",
				"3 PM": "0",
				"4 PM": "1",
				"5 PM": "0",
				"6 PM": "1",
				"7 PM": "0",
				"8 PM": "1",
				"9 PM": "0",
				"10 PM": "1",
				"11 PM": "0",
				"12 AM": "1",
				"1 AM": "0",
				"2 AM": "1",
				"3 AM": "0",
				"4 AM": "1",
				"5 AM": "0",
			},
		},
		{
			"Station": "Night Incharge",
			"timings": {
				"6 AM": "0",
				"7 AM": "1",
				"8 AM": "0",
				"9 AM": "1",
				"10 AM": "0",
				"11 AM": "1",
				"12 PM": "0",
				"1 PM": "1",
				"2 PM": "0",
				"3 PM": "1",
				"4 PM": "0",
				"5 PM": "1",
				"6 PM": "0",
				"7 PM": "1",
				"8 PM": "0",
				"9 PM": "1",
				"10 PM": "0",
				"11 PM": "1",
				"12 AM": "0",
				"1 AM": "1",
				"2 AM": "0",
				"3 AM": "1",
				"4 AM": "0",
				"5 AM": "1"
			},
		},
		{
			"Station": "SOK",
			"timings": {
				"6 AM": "1",
				"7 AM": "0",
				"8 AM": "1",
				"9 AM": "0",
				"10 AM": "1",
				"11 AM": "0",
				"12 PM": "1",
				"1 PM": "0",
				"2 PM": "1",
				"3 PM": "0",
				"4 PM": "1",
				"5 PM": "0",
				"6 PM": "1",
				"7 PM": "0",
				"8 PM": "1",
				"9 PM": "0",
				"10 PM": "1",
				"11 PM": "0",
				"12 AM": "1",
				"1 AM": "0",
				"2 AM": "1",
				"3 AM": "0",
				"4 AM": "1",
				"5 AM": "0",
			},
		},
		{
			"Station": "Shift Running",
			"timings": {
				"6 AM": "0",
				"7 AM": "1",
				"8 AM": "0",
				"9 AM": "1",
				"10 AM": "0",
				"11 AM": "1",
				"12 PM": "0",
				"1 PM": "1",
				"2 PM": "0",
				"3 PM": "1",
				"4 PM": "0",
				"5 PM": "1",
				"6 PM": "0",
				"7 PM": "1",
				"8 PM": "0",
				"9 PM": "1",
				"10 PM": "0",
				"11 PM": "1",
				"12 AM": "0",
				"1 AM": "1",
				"2 AM": "0",
				"3 AM": "1",
				"4 AM": "0",
				"5 AM": "1"
			},
		},
		{
			"Station": "Total",
			"timings": {
				"6 AM": "1",
				"7 AM": "0",
				"8 AM": "1",
				"9 AM": "0",
				"10 AM": "1",
				"11 AM": "0",
				"12 PM": "1",
				"1 PM": "0",
				"2 PM": "1",
				"3 PM": "0",
				"4 PM": "1",
				"5 PM": "0",
				"6 PM": "1",
				"7 PM": "0",
				"8 PM": "1",
				"9 PM": "0",
				"10 PM": "1",
				"11 PM": "0",
				"12 AM": "1",
				"1 AM": "0",
				"2 AM": "1",
				"3 AM": "0",
				"4 AM": "1",
				"5 AM": "0",
			},
		},
	],
	testCoverageLabels: [
		"6 AM",
		"7 AM",
		"8 AM",
		"9 AM",
		"10 AM",
		"11 AM",
		"12 PM",
		"1 PM",
		"2 PM",
		"3 PM",
		"4 PM",
		"5 PM",
		"6 PM",
		"7 PM",
		"8 PM",
		"9 PM",
		"10 PM",
		"11 PM",
		"12 AM",
		"1 AM",
		"2 AM",
		"3 AM",
		"4 AM",
		"5 AM",
	],
	nonCoverageDailyViewLabels: [
		{
			label: '06-00',
			value: '6 AM',
		},
		{
			label: '07-00',
			value: '7 AM',
		},
		{
			label: '08-00',
			value: '8 AM',
		},
		{
			label: '09-00',
			value: '9 AM',
		},
		{
			label: '10-00',
			value: '10 AM',
		},
		{
			label: '11-00',
			value: '11 AM',
		},
		{
			label: '12-00',
			value: '12 PM',
		},
		{
			label: '13-00',
			value: '1 PM',
		},
		{
			label: '14-00',
			value: '2 PM',
		},
		{
			label: '15-00',
			value: '3 PM',
		},
		{
			label: '16-00',
			value: '4 PM',
		},
		{
			label: '17-00',
			value: '5 PM',
		},
		{
			label: '18-00',
			value: '6 PM',
		},
		{
			label: '19-00',
			value: '7 PM',
		},
		{
			label: '20-00',
			value: '8 PM',
		},
		{
			label: '21-00',
			value: '9 PM',
		},
		{
			label: '22-00',
			value: '10 PM',
		},
		{
			label: '23-00',
			value: '11 PM',
		},
		{
			label: '00-00',
			value: '12 AM',
		},
		{
			label: '01-00',
			value: '1 AM',
		},
		{
			label: '02-00',
			value: '2 AM',
		},
		{
			label: '03-00',
			value: '3 AM',
		},
		{
			label: '04-00',
			value: '4 AM',
		},
		{
			label: '05-00',
			value: '5 AM',
		},
	],
	nonCoverageDailyViewLabelsFor30Min: [
		{ label: '00-00', value: '12:00 AM' },
		{ label: '00-30', value: '12:30 AM' },
		{ label: '01-00', value: '01:00 AM' },
		{ label: '01-30', value: '01:30 AM' },
		{ label: '02-00', value: '02:00 AM' },
		{ label: '02-30', value: '02:30 AM' },
		{ label: '03-00', value: '03:00 AM' },
		{ label: '03-30', value: '03:30 AM' },
		{ label: '04-00', value: '04:00 AM' },
		{ label: '04-30', value: '04:30 AM' },
		{ label: '05-00', value: '05:00 AM' },
		{ label: '05-30', value: '05:30 AM' },
		{ label: '06-00', value: '06:00 AM' },
		{ label: '06-30', value: '06:30 AM' },
		{ label: '07-00', value: '07:00 AM' },
		{ label: '07-30', value: '07:30 AM' },
		{ label: '08-00', value: '08:00 AM' },
		{ label: '08-30', value: '08:30 AM' },
		{ label: '09-00', value: '09:00 AM' },
		{ label: '09-30', value: '09:30 AM' },
		{ label: '10-00', value: '10:00 AM' },
		{ label: '10-30', value: '10:30 AM' },
		{ label: '11-00', value: '11:00 AM' },
		{ label: '11-30', value: '11:30 AM' },
		{ label: '12-00', value: '12:00 PM' },
		{ label: '12-30', value: '12:30 PM' },
		{ label: '13-00', value: '01:00 PM' },
		{ label: '13-30', value: '01:30 PM' },
		{ label: '14-00', value: '02:00 PM' },
		{ label: '14-30', value: '02:30 PM' },
		{ label: '15-00', value: '03:00 PM' },
		{ label: '15-30', value: '03:30 PM' },
		{ label: '16-00', value: '04:00 PM' },
		{ label: '16-30', value: '04:30 PM' },
		{ label: '17-00', value: '05:00 PM' },
		{ label: '17-30', value: '05:30 PM' },
		{ label: '18-00', value: '06:00 PM' },
		{ label: '18-30', value: '06:30 PM' },
		{ label: '19-00', value: '07:00 PM' },
		{ label: '19-30', value: '07:30 PM' },
		{ label: '20-00', value: '08:00 PM' },
		{ label: '20-30', value: '08:30 PM' },
		{ label: '21-00', value: '09:00 PM' },
		{ label: '21-30', value: '09:30 PM' },
		{ label: '22-00', value: '10:00 PM' },
		{ label: '22-30', value: '10:30 PM' },
		{ label: '23-00', value: '11:00 PM' },
		{ label: '23-30', value: '11:30 PM' }
	],
	companyLevelSections: [],
	hideShowStationAddEditPopup: false,
	stationDetails: {
		name: ""
	},
	hideShowBulkEditNonCoveragePopup: false,
	bulkSavePerson: 0,
	searchedNonCoverageStation: "",
	filterActivityData: [],
	rawDailyActivities: [],
	frequency_hourly_value_list: [
		{
			title: 'Every 30 mins',
			value: '0.5'
		},
		{
			title: 'Every 1 Hr',
			value: '1.0'
		},
		{
			title: 'Every 2 Hrs',
			value: '2.0'
		},
		{
			title: 'Every 4 Hrs',
			value: '3.0'
		},
		{
			title: 'Every 5 Hrs',
			value: '4.0'
		},
		{
			title: 'Every 6 Hrs',
			value: '5.0'
		},
		{
			title: 'Every 7 Hrs',
			value: '6.0'
		},
		{
			title: 'Every 8 Hrs',
			value: '7.0'
		},
		{
			title: 'Every 9 Hrs',
			value: '8.0'
		},
		{
			title: 'Every 10 Hrs',
			value: '9.0'
		},
		{
			title: 'Every 11 Hrs',
			value: '10.0'
		},
		{
			title: 'Every 12 Hrs',
			value: '11.0'
		}
	],
	editSelectNonCoverageActivity: {},
	answeredActivityData: [],
	storeSectionDetails: {},
	showStoreSectionModal: false,
	nonCoverageActivityDetails: {},
	timeSlots: [
		{
			"label": "06:00",
			"value": "06:00"
		},
		{
			"label": "07:00",
			"value": "07:00"
		},
		{
			"label": "08:00",
			"value": "08:00"
		},
		{
			"label": "09:00",
			"value": "09:00"
		},
		{
			"label": "10:00",
			"value": "10:00"
		},
		{
			"label": "11:00",
			"value": "11:00"
		},
		{
			"label": "12:00",
			"value": "12:00"
		},
		{
			"label": "13:00",
			"value": "13:00"
		},
		{
			"label": "14:00",
			"value": "14:00"
		},
		{
			"label": "15:00",
			"value": "15:00"
		},
		{
			"label": "16:00",
			"value": "16:00"
		},
		{
			"label": "17:00",
			"value": "17:00"
		},
		{
			"label": "18:00",
			"value": "18:00"
		},
		{
			"label": "19:00",
			"value": "19:00"
		},
		{
			"label": "20:00",
			"value": "20:00"
		},
		{
			"label": "21:00",
			"value": "21:00"
		},
		{
			"label": "22:00",
			"value": "22:00"
		},
		{
			"label": "23:00",
			"value": "23:00"
		},
		{
			"label": "00:00",
			"value": "00:00"
		},
		{
			"label": "01:00",
			"value": "01:00"
		},
		{
			"label": "02:00",
			"value": "02:00"
		},
		{
			"label": "03:00",
			"value": "03:00"
		},
		{
			"label": "04:00",
			"value": "04:00"
		},
		{
			"label": "05:00",
			"value": "05:00"
		},
	]
	,
	daysList: [
		{
			label: 'All Days',
			value: 'all'
		},
		{
			label: 'Mon',
			value: 'monday'
		},
		{
			label: 'Tue',
			value: 'tuesday'
		},
		{
			label: 'Wed',
			value: 'wednesday'
		},
		{
			label: 'Thu',
			value: 'thursday'
		},
		{
			label: 'Fri',
			value: 'friday'
		},
		{
			label: 'Sat',
			value: 'saturday'
		},
		{
			label: 'Sun',
			value: 'sunday'
		},
	],
	dailyActivityView: false,
	updatedFormatCoverageActivities: [],
	updatedEditCoverageActivity: {},
	hideShowNewCoverageActivity: false,
	coverageTableLoading: false,
	selectedStoreSettingSection: null,
	selectedStoreSettingStation: null,
	groupedStoreSettingCoverageActivities: [],
	groupedStoreSettingNonCoverageActivities: [],
	hideShowCoverageGroupedCoverageActivityModal: false,
	storeSettingsNonCoverageActivityIds: [],
	showMultipleFilteredNonCoverageActivities: false,
	filteredNonCoverageActivities: [],
	workforceOptions: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
	groupedDailyActivities: {},
	activityTypeList: [],
	activityDialogVisible: false,
	activityName: "",
	selectedActivity: {},
	allStoreType: false,
	dineIn: false,
	isRestroom: false,
	driveThrough: false,
	isDelivery: false,
	isDailyActivitesLoading: false,
	isAddActivityInProgress: false,
	// Store guidelines data
	staffDetails: {},
	showStoreDetailsSaveConfirmation: false,
	storeDetailsSaveChoice: '2',
	nonCoverageActivityHourlyView: [],
	nonCoverageActivityHourlyViewSummary: [],
	selectedHourlyActivitiesIds: [],
	selectedHourlyViewDays: [],
	selectedHourlyViewStartTime: "",
	selectedHourlyViewEndTime: "",
	selectedHourlyViewNumberOfPeople: 0,
	selectedHourlyFilterActivities: [],
	selectedHourlyDays: [],
};

const mutations = {
	updateLocations: (state, payload) => {
		state.locations = payload;
	},
	updateCountry: (state, payload) => {
		state.selectedCountry = payload;
	},
	updateRegion: (state, payload) => {
		state.selectedRegion = payload;
	},
	updateSubRegion: (state, payload) => {
		state.selectedSubRegion = payload;
	},
	updateOutlet: (state, payload) => {
		state.selectedOutlet = payload;
	},
	updateSections: (state, payload) => {
		state.storeSections = payload;
	},
	updateShowSection: (state, payload) => {
		state.showSectionModal = payload;
	},
    updateSectionData: (state, payload) => {
        state.sectionData = payload;
    },
    updateDailyActivities: (state, payload) => {
        state.dailyActivities = payload;
    },
    updateCoverageActivites: (state, payload) => {
        state.coverageActivities = payload;
    },
    updateFunctions: (state, payload) => {
        state.functions = payload;
    },
    updateDepartments: (state, payload) => {
        state.departments = payload;
    },
    updateDesignations: (state, payload) => {
        state.designations = payload;
    },
	updateOutlets: (state, payload) => {
		state.outlets = payload;
	},
	updateShowCoverageActivity: (state, payload) => {
		state.showCoverageActivity = payload;
	},
	updateCoverageActivityDetails: (state, payload) => {
		state.coverageActivityDetails = payload;
	},
	updateSelectedFunction: (state, payload) => {
		state.selectedFunctions = payload;
	},
	updatePlanningType: (state, payload) => {
		state.planningType = payload;
	},
	updateSelectedSection: (state, payload) => {
		state.selectedSections = payload;
	},
	updateAverageTimePerCategory: (state, payload) => {
		state.averageTimePerCategory = payload;
	},
	updateCategoryList: (state, payload) => {
		state.category_list = payload;
	},
	updateNumTeancListData: (state, payload) => {
		state.numTeancListData = payload;
	},
	updateTransactionActivitiesList:  (state, payload) => {
		state.transactionActivitiesList = payload;
	},
	updateOrderTypeList: (state, payload) => {
		state.orderTypeList = payload;
	},
	updateDepartmentList: (state, payload) => {
		state.department_list = payload;
	},
	updateIsAdmin: (state, payload) => {
		state.is_admin = payload;
	},
	updatePreparationActivity: (state, payload) => {
		state.preparation_activity = payload;
	},
	updateAddTime: (state, payload) => {
		state.add_time = payload;
	},
	updatePlanningLevel: (state, payload) => {
		state.planningLevel = payload;
	},
	updateDepartmentActivities: (state, payload) => {
		state.departmentActivities = payload;
	},
	updateSelectedCategories: (state, payload) => {
		state.selected_categories = payload;
	},
	updateSelectPlanningLevelDepartment: (state, payload) => {
		state.selectPlanningLevelDepartment = payload;
	},
	updateSelectedSubCategories: (state, payload) => {
		state.selectedSubCategories = payload;
	},
	updateSubcategoryList: (state, payload) => {
		state.subcategoryList = payload;
	},
	updateChangeKeys: (state, payload) => {
		state.change_keys = payload;
	},
	updateOverallAverage: (state, payload) => {
		state.overallAverage = payload;
	},
	updateSubCategoryActivityList: (state, payload) => {
		state.subCategoryActivityList = payload;
	},
	updateSelectedDepartmentList: (state, payload) => {
		state.selectedDepartmentList = payload;
	},
	updateTransactionThresholdRange: (state, payload) => {
		state.transactionThresholdRange = payload;
	},
	updateShowNonCoverageActivityPopup: (state, payload) => {
		state.showNonCoverageActivityPopup = payload;
	},
	updateSelectedFrequency: (state, payload) => {
		state.selectedFrequency = payload;
	},
	updateSelectedPlanBy: (state, payload) => {
		state.selectedPlanBy = payload;
	},
	updateEditSectionActivity: (state, payload) => {
		state.editSectionActivity = payload;
	},
	updateSelectedOrderType: (state, payload) => {
		state.selectedOrderType = payload;
	},
	updateQuantityArr: (state, payload) => {
		state.quantityArr = payload;
	},
	updateStoreDetailsId: (state, payload) => {
		state.store_details_id = payload;
	},
	updatePlanType: (state, payload) => {
		state.planType = payload;
	},
	updateSelectedFunctionList: (state, payload) => {
		state.selected_function_list = payload;
	},
	updateFilterFunctions: (state, payload) => {
		state.filter_functions = payload;
	},
	updateFilterFunctionsList: (state, payload) => {
		state.filter_functionsList = payload;
	},
	updateNonCoverageActivities: (state, payload) => {
		state.non_coverage_activities = payload;
	},
	updateSectionFunctionData: (state, payload) => {
		state.sectionFunctionData = payload;
	},
	updateSearchedSection: (state, payload) => {
		state.searchedSection = payload;
	},
	updateSearchedCoverageActivity: (state, payload) => {
		state.searchedCoverageActivity = payload;
	},
	updateHideShowNonCoverageActivity: (state, payload) => {
		state.hideShowNonCoverageActivity = payload;
	},
	updateSelectedFilterSections: (state, payload) => {
		state.selectedFilterSections = payload;
	},
	updateSelectedFilterStations: (state, payload) => {
		state.selectedFilterStations = payload;
	},
	updateSelectedFilterDays: (state, payload) => {
		state.selectedFilterDays = payload;
	},
	updateCompanyLevelSections: (state, payload) => {
		state.companyLevelSections = payload;
	},
	updateHideShowStationAddEditPopup: (state, payload) => {
		state.hideShowStationAddEditPopup = payload;
	},
	updateStationDetails: (state, payload) => {
		state.stationDetails = payload;
	},
	updateTestNonCoverageActivityData: (state, payload) => {
		state.testNonCoverageActivityData = payload;
	},
	updateHideShowBulkEditNonCoveragePopup: (state, payload) => {
		state.hideShowBulkEditNonCoveragePopup = payload;
	},
	updateBulkSavePerson: (state, payload) => {
		state.bulkSavePerson = payload;
	},
	updateSearchedNonCoverageStation: (state, payload) => {
		state.searchedNonCoverageStation = payload;
	},
	updateFilterActivity: (state, payload) => {
		state.filterActivityData = payload;
	},
	updateRawDailyActivities: (state, payload) => {
		state.rawDailyActivities = payload;
	},
	updateEditSelectNonCoverageActivity: (state, payload) => {
		state.editSelectNonCoverageActivity = payload;
	},
	updateAnsweredActivityData: (state, payload) => {
		state.answeredActivityData = payload;
	},
	updateStoreSectionDetails: (state, payload) => {
		state.storeSectionDetails = payload;
	},
	updateShowStoreSectionModal: (state, payload) => {
		state.showStoreSectionModal = payload;
	},
	updateNonCoverageActivityDetails: (state, payload) => {
		state.nonCoverageActivityDetails = payload;
	},
	updateDailyActivityView: (state, payload) => {
		state.dailyActivityView = payload;
	},
	updateUpdatedFormatCoverageActivities: (state, payload) => {
		state.updatedFormatCoverageActivities = payload;
	},
	updateUpdatedEditCoverageActivity: (state, payload) => {
		state.updatedEditCoverageActivity = payload;
	},
	updateHideShowNewCoverageActivity: (state, payload) => {
		state.hideShowNewCoverageActivity = payload;
	},
	updateCoverageTableLoading: (state, payload) => {
		state.coverageTableLoading = payload;
	},
	updateSelectedStoreSettingSection: (state, payload) => {
		state.selectedStoreSettingSection = payload;
	},
	updateSelectedStoreSettingStation: (state, payload) => {
		state.selectedStoreSettingStation = payload;
	},
	updateGroupedStoreSettingCoverageActivities: (state, payload) => {
		state.groupedStoreSettingCoverageActivities = payload;
	},
	updateGroupedStoreSettingNonCoverageActivities: (state, payload) => {
		state.groupedStoreSettingNonCoverageActivities = payload;
	},
	updateHideShowCoverageGroupedCoverageActivityModal: (state, payload) => {
		state.hideShowCoverageGroupedCoverageActivityModal = payload;
	},
	updateStoreSettingsNonCoverageActivityIds: (state, payload) => {
		state.storeSettingsNonCoverageActivityIds = payload;
	},
	updateShowMultipleFilteredNonCoverageActivities: (state, payload) => {
		state.showMultipleFilteredNonCoverageActivities = payload;
	},
	updateFilteredNonCoverageActivities: (state, payload) => {
		state.filteredNonCoverageActivities = payload;
	},
	updateGroupedDailyActivities: (state, payload) => {
		state.groupedDailyActivities = payload;
	},
	updateActivityTypeList: (state, payload) => {
		state.activityTypeList = payload;
	},
	updateActivityDialogVisible: (state, payload) => {
		state.activityDialogVisible = payload;
	},
	updateActivityName: (state, payload) => {
		state.activityName = payload;
	},
	updateSelectedActivity: (state, payload) => {
		state.selectedActivity = payload;
	},
	updateAllStoreType: (state, payload) => {
		state.allStoreType = payload;
	},
	updateDineIn: (state, payload) => {
		state.dineIn = payload;
	},
	updateIsRestroom: (state, payload) => {
		state.isRestroom = payload;
	},
	updateDriveThrough: (state, payload) => {
		state.driveThrough = payload;
	},
	updateIsDelivery: (state, payload) => {
		state.isDelivery = payload;
	},
	updateIsDailyActivitesLoading: (state, payload) => {
		state.isDailyActivitesLoading = payload;
	},
	updateIsAddActivityInProgress: (state, payload) => {
		state.isAddActivityInProgress = payload;
	},
	// Store guidelines
	updateStaffDetails: (state, payload) => {
		state.staffDetails = payload;
	},
	updateShowStoreDetailsSaveConfirmation: (state, payload) => {
		state.showStoreDetailsSaveConfirmation = payload;
	},
	updateStoreDetailsSaveChoice: (state, payload) => {
		state.storeDetailsSaveChoice = payload;
	},
	updateNonCoverageActivityHourlyView: (state, payload) => {
		state.nonCoverageActivityHourlyView = payload;
	},
	updateNonCoverageActivityHourlyViewSummary: (state, payload) => {
		state.nonCoverageActivityHourlyViewSummary = payload;
	},
	updateSelectedHourlyActivitiesIds: (state, payload) => {
		state.selectedHourlyActivitiesIds = payload;
	},
	updateSelectedHourlyViewDays: (state, payload) => {
		state.selectedHourlyViewDays = payload;
	},
	updateSelectedHourlyViewStartTime: (state, payload) => {
		state.selectedHourlyViewStartTime = payload;
	},
	updateSelectedHourlyViewEndTime: (state, payload) => {
		state.selectedHourlyViewEndTime = payload;
	},
	updateSelectedHourlyViewNumberOfPeople: (state, payload) => {
		state.selectedHourlyViewNumberOfPeople = payload;
	},
	updateSelectedHourlyFilterActivities: (state, payload) => {
		state.selectedHourlyFilterActivities = payload;
	},
	updateSelectedHourlyDays: (state, payload) => {
		state.selectedHourlyDays = payload;
	},
};

export default {
	state,
	mutations,
	namespaced: true,
};
